import request from '../utils/request';

export default {
  ywbl_jysq(data) {
    return request.post('/ywbl/ywbl_jysq', data);
  },
  gdgl_gdlz(data) {
    return request.post('/ywbl/gdgl_gdlz', data);
  },
  gdcx_cxgd(data) {
    return request.get('/ywbl/gdcx_cxgd', data);
  },
  ywcx_jysqcx(data) {
    return request.get('/ywbl/ywcx_jysqcx', data);
  },
  ywcx_cxdz(data) {
    return request.get('/ywbl/ywcx_cxdz', data);
  },
  ywbl_dysq(data) {
    return request.post('/ywbl/ywbl_dysq', data);
  },
  ywcx_dyxxcx(data) {
    return request.get('/ywbl/ywcx_dyxxcx', data);
  },
  qxgl_dmyscx(data) {
    return request.get('/zwmk/qxgl/qxgl_dmyscx', data);
  },
  ywbl_cqbgsq(data) {
    return request.post('/ywbl/ywbl_cqbgsq', data);
  },
  ywcx_cqbgcx(data) {
    return request.get('/ywbl/ywcx_cqbgcx', data);
  },
  ywbl_fwzlsq(data) {
    return request.post('/ywbl/ywbl_fwzlsq', data);
  },
  ywcx_fwzlcx(data) {
    return request.get('/ywbl/ywcx_fwzlcx', data);
  },
  ywbl_khsq(data) {
    return request.post('/ywbl/ywbl_khsq', data);
  },
  ywcx_khcx(data) {
    return request.get('/ywbl/ywcx_khcx', data);
  },
  ywbl_nqtgsq(data) {
    return request.post('/ywbl/ywbl_nqtgsq', data);
  },
  ywcx_nqtgcx(data) {
    return request.get('/ywbl/ywcx_nqtgcx', data);
  },
  ywbl_fcdjsq(data) {
    return request.post('/ywbl/ywbl_fcdjsq', data);
  },
  ywcx_fcdjcx(data) {
    return request.get('/ywbl/ywcx_fcdjcx', data);
  },
  ywbl_ghsq(data) {
    return request.post('/ywbl/ywbl_ghsq', data);
  },
  ywcx_ghsqcx(data) {
    return request.get('/ywbl/ywcx_ghsqcx', data);
  },
  zhcxmk_dzfwcx(data) {
    return request.get('/ywbl/zhcxmk_dzfwcx', data);
  },
  ywbl_dgsq(data) {
    return request.post('/ywbl/ywbl_dgsq', data);
  },
  khmk_khjzcx(data) {
    return request.get('/ywbl/khmk_khjzcx', data);
  },
  gdgl_zfgd(data) {
    return request.post('/ywbl/gdgl_zfgd', data);
  },
  zhcxmk_fcxxcx(data) {
    return request.get('/ywbl/zhcxmk_fcxxcx', data);
  },
};



// WEBPACK FOOTER //
// ./src/api/ywbl.api.js